import React, { useContext } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import Section from 'components/Section'
import ProgressMeter from 'components/ProgressMeter'
import { JazeelContext } from 'Influencers/utils/JazeelContext'
import i18n from 'i18n'
import { RTL } from '../../../locales/currentLang'
import langUrl from '../../../CampaignSystem/utils/langUrl'
const Content = styled.p`
  height: 2.25em;
  width: auto;
  color: #909294;
  font-size: 0.875em;
  line-height: 1.3em;
  margin-top: -1.5em;
`
const CompleteLink = styled(Link)`
  color: #54ce9d;

  font-size: 0.875em;
  line-height: 1.125em;
  float: ${props => props.theme.dir};
`
const IconTo = styled(FontAwesomeIcon)`
  transform: ${props =>
    props.dir === 'true' ? 'rotate(180deg)' : 'rotate(0deg)'};
`
export default function ProfileSection({ name, website, percent, to }) {
  const { isSmallMobile } = useContext(JazeelContext)
  return (
    <Section
      title={i18n.t('influencer.dashboard.profile')}
      width={isSmallMobile ? '94.733vw' : '100%'}
    >
      {name && (
        <Content className="ml-1">
          {name} {website ? '|' + website : ''}
        </Content>
      )}

      <ProgressMeter progress={percent} />
      <CompleteLink to={{ pathname: to, state: { percent } }}>
        {i18n.t('general.edit')}
        <IconTo
          dir={RTL().toLocaleString()}
          icon={faChevronRight}
          color="#777777"
          className="ml-2 mt-1 mr-2"
        />
      </CompleteLink>
    </Section>
  )
}

ProfileSection.propTypes = {
  name: PropTypes.string,
  website: PropTypes.string,
  percent: PropTypes.number,
  to: PropTypes.string,
}
ProfileSection.defaultProps = {
  to: `/${langUrl}/brand/profile`,
}
